import type { NonceGenerator } from '../contexts/NonceGeneratorContextProvider';

export const CRYPTO_NONCE_GENERATOR: NonceGenerator = {
  generateNonce(buf) {
    window.crypto.getRandomValues(new Uint8Array(buf));
  },
};
